<template>
  <div
    class="tour-card-horizontal"
    :class="{ loading }"
    ref="tourRef"
    @contextmenu="setLocalStorageInfo"
  >
    <a
      :href="link"
      :title="title"
      ref="tour"
      target="_blank"
      :class="['tour-card-horizontal__link', { 'product' : isSponsored }]"
      v-bind="topsortData"
      @click.stop.prevent="openTour('image'); $emit('init-topsort-id')"
    >
      <div ref="imageRef" class="tour-card-horizontal__image">
        <img
          :class="{
            'lazyload': lazyImage,
           }"
          loading="lazy"
          :alt="title"
          :src="imageUrlNoMounted"
          :srcset="imageUrl1x1"
          :data-src="imageUrl"
          :data-srcset="imageUrl"
        />

        <div class="tour-card-horizontal__image__top">
          <div class="tour-card-horizontal__image__top__left">
            <div
              class="tour-card-horizontal__image__top__super-expert"
              v-if="isSuperExpert"
            >
              {{ $t('serp.awards.superExpert') }}
              <div class="tour-card-horizontal__image__top__super-expert-icon">
                <Icon icon="ribbon" />
              </div>
            </div>

            <div
              class="tour-card-horizontal__image__top__type"
              v-if="type"
              v-text="type"
            />

            <div class="tour-card-horizontal__image__top__new" v-if="isNew">
              <span v-text="$t('serp.tourCard.new')" />
            </div>

            <div
              class="tour-card-horizontal__image__top__private"
              v-if="showGuaranteeLabel"
            >
              <span v-text="$t('serp.tourCard.guarantee_label')" />
            </div>
            <div class="tour-card-horizontal__image__top__private" v-else-if="isPrivate">
              <span v-text="$t('serp.tourCard.private_label')" />
            </div>

            <div class="tour-card-horizontal__image__top__additional" v-if="isRecommended">
              <span v-text="$t('serp.tourCard.recommended')" />
            </div>

            <div class="tour-card-horizontal__image__top__additional" v-if="isSponsored">
              <span v-text="$t('serp.tourCard.sponsored')" />
            </div>

            <div
              class="tour-card-horizontal__image__top__black_friday"
              v-if="isBlackFriday"
            >
              <span v-text="$t('serp.tourCard.blackFriday')" />
            </div>
          </div>

          <div
            class="tour-card-horizontal__image__top__favorite"
            :data-itemid="tour.id"
            @click.stop.prevent="toggleFavorite"
          >
            <Icon icon="heart" :class="{ favorite: isFavorite }" />
          </div>
        </div>

        <div class="tour-card-horizontal__image__bottom">
          <div
            class="tour-card-horizontal__image__expert font-text"
            @click.stop.prevent="clickExpert"
          >
            <img
              class="tour-card-horizontal__image__expert__photo lazyload"
              :class="{
                  'awards_photo': getAwards,
               }"
              loading="lazy"
              :data-src="expert.avatar"
              :data-srcset="expert.avatar"
              :src="expert.avatar"
              :srcset="expert.avatar1x1"
              :alt="expert.name"
            />

            <div class="tour-card-horizontal__image__expert__title">
              <div
                class="tour-card-horizontal__image__expert__name font-h1"
                :class="{
                  'awards_title': getAwards,
                 }"
                v-text="expert.name"
              />
              <div
                v-if="getAwards"
                :class="'awards_item ' + getAwards.code"
                v-text="getAwards.name"
              />
            </div>
          </div>
        </div>
      </div>
    </a>
    <div class="tour-card-horizontal__body">
      <div class="tour-card-horizontal__body__info">
        <div class="tour-card-horizontal__body__rating">
          <div class="tour-card-horizontal__body__rating__icon">
            <Icon icon="tour-rating-star" />
          </div>

          <div
            v-if="expert.rating === 0"
            class="tour-card-horizontal__body__rating__new"
          >
            {{ $t("serp.tourCard.new") }}
          </div>

          <template v-else>
            <div
              class="tour-card-horizontal__body__rating__rating"
              v-text="expert.rating"
            />

            <div
              class="tour-card-horizontal__body__rating__number"
              v-text="expert.reviews"
            />
          </template>

          <div class="tour-card-horizontal__body__location font-text">
             {{ ` · ${location}` }}
          </div>
        </div>
        <div class="tour-card-horizontal__body__title font-semibold" @click.stop.prevent="openTour('title')">
          <span v-text="title" />
        </div>
        <div class="tour-card-horizontal__body__description">
          <span v-html="description" />
        </div>
        <div class="tour-card-horizontal__body__route" v-if="this.tour.locations.length">
          <div class="route__title">{{  $t("serp.tourCard.routeTitle") }}</div>
          <div class="route__block">
            <div class="route__text" :class="{'opened' : isShowFullRoute}">
              {{getRoute}}{{isShowFullRoute ? ', '+getFullRoute : ""}}
              <span
                class="route__show-more"
                @click="showFullRoute"
                v-if="moreLocationsAmount"
              >
                {{!isShowFullRoute ? getMoreRouteLocations :  $t("serp.tourCard.hide") }}
              </span>
            </div>
          </div>
        </div>
        <div class="tour-card-horizontal__body__dates-tablet" v-if="isTablet">
          <div class="tour-card-horizontal__body__date" v-if="dates[0].date">
            <div class="tour-card-horizontal__body__date__text">
              {{ dates[0].date }}
            </div>
          </div>
          <div class="tour-card-horizontal__body__date" v-if="dates[0].freeSpaces">
            <div class="tour-card-horizontal__body__date__free-spaces" >
              <Icon icon="lightning" />
              <span v-text="dates[0].freeSpaces" />
            </div>
          </div>
          <div
            v-if="moreDates > 1"
            class="tour-card-horizontal__body__more-dates"
            @click.stop.prevent="openTour('more dates')"
          >
            +{{ moreDates }}
            {{
              moreDates > 4
                ? $t("serp.tourCard.moreDates[2]")
                : moreDates > 1
                ? $t("serp.tourCard.moreDates[1]")
                : $t("serp.tourCard.moreDates[0]")
            }}
          </div>
        </div>
      </div>
      <div class="tour-card-horizontal__body__price-dates">

        <div class="tour-card-horizontal__body__price">
          <div class="tour-card-horizontal__body__price-block">
            <span
              class="tour-card-horizontal__body__price__original font-h1"
              :class="{'tour-card-horizontal__body__price__original--discount': priceDiscount,}"
              v-text="price"
            />
            <span
              class="tour-card-horizontal__body__price__discount font-h1"
              v-if="priceDiscount"
              v-text="priceDiscount"
            />
            <div
              class="tour-card-horizontal__body__discount font-text"
              v-if="priceDiscount"
              v-text="priceDiscountPercent"
            />
          </div>

          <div class="tour-card-horizontal__body__price__duration">
            <div class="tour-card-horizontal__body__price__duration-days" v-if="!isOneDay">
              <icon icon="sun"/>
              <span>
                 {{getDaysAndNights.days}}
              </span>
            </div>
            <div class="tour-card-horizontal__body__price__duration-nights" v-if="!isOneDay">
              <icon icon="moon"/>
              <span>
                {{getDaysAndNights.nights}}
              </span>
            </div>
            <div class="tour-card-horizontal__body__price__duration-hours" v-if="isOneDay && getHours">
              <icon icon="stopwatch"/>
              <span>
                {{getHours}}
              </span>
            </div>
          </div>
        </div>
        <div class="tour-card-horizontal__body__dates" v-if="!isTablet">
          <div class="tour-card-horizontal__body__date"  v-if="dates[0].date">
            <div class="tour-card-horizontal__body__date__text">
              {{ dates[0].date }}
            </div>

          </div>
          <div class="tour-card-horizontal__body__date" v-if=" dates[0].freeSpaces">
            <div class="tour-card-horizontal__body__date__free-spaces" >
              <Icon icon="lightning" />
              <span v-text="dates[0].freeSpaces" />
            </div>
          </div>
          <div
            v-if="moreDates > 1"
            class="tour-card-horizontal__body__more-dates"
            @click.stop.prevent="openTour('more dates')"
          >
            +{{ moreDates }}
            {{
              moreDates > 4
                ? $t("serp.tourCard.moreDates[2]")
                : moreDates > 1
                ? $t("serp.tourCard.moreDates[1]")
                : $t("serp.tourCard.moreDates[0]")
            }}
          </div>
        </div>
        <yt-button
          class="tour-card-horizontal__body__open-tour"
          color="gray"
          :squared = "true"
          size="md"
          @click="openTour('button')"
        >{{$t("serp.tourCard.viewTour")}}</yt-button>
      </div>
    </div>
    <component
      v-bind:is="'script'"
      type="application/ld+json"
      v-html="this.getTourCardMeta"
    >
    </component>
  </div>

</template>
<script>

import { defineComponent, ref, computed, onMounted } from "vue";
import {useAnalytics} from "@/plugins/events";
import {useSharedStore} from "@/state/shared-store";
import {getImageCdnUrl} from "@/assets/js/utils/get-img-cdn";

import Icon from "@/components/icons/index.vue";
import YtButton from "@/components/ui-kit/yt-button";
import {abTestController} from "@/plugins/abtest";
import {i18n} from "@/plugins/i18n";
import {mapActions, mapState} from "vuex";
import {ytEvents} from "@/plugins/analytics";
import {axiosUser} from "@/services/scopes/axios-user";
import {format, isSameMonth, isSameYear, isThisYear} from "date-fns";
import {ru} from "date-fns/locale";
export default defineComponent({
  name: "tour-card-horizontal",
  components: {
    Icon,
    YtButton
  },
  data() {
    return {
      eventFavoriteName: "favorite-tour",
      pendingFavorite: false,
      isRussian: i18n.locale === "ru",
      isTablet: false,
      isShowFullRoute: false,
      moreLocationsAmount: 0,
      toursWithAwards: [
        25392,
        29738,
        11073,
        23607,
        17952,
        17952,
        7129,
        25127,
        10557,
        28022
      ]
    };
  },
  props: {
    tour: {
      type: Object,
      required: true,
    },
    query: {
      type: Object,
      required: true,
    },
    lazyImage: {
      type: Boolean,
      default: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    participants: {
      type: String,
      default: "1",
    },
    isSuperExpert: {
      type: Boolean,
      default: false,
    },
    index: {
      type: Number,
      default: "1",
    },
    locationInfo: {
      type: Object,
      default: () => {
        return [];
      },
    }
  },
  setup(props) {
    const { trackEvent } = useAnalytics();
    const { user } = useSharedStore();

    const tourRef = ref(undefined);
    const imageRef = ref(undefined);
    const mounted = ref(false);

    const link = computed(() => props.tour.link);
    const title = computed(() => props.tour.title);
    const preview = computed(() => props.tour.preview_image);
    const isPrivate = computed(() => props.tour.is_private);
    const isGuarantee = computed(() => props.tour.dates.group.guarantee);
    const isSponsored = computed(() => props.tour.sponsored);
    const topsortResolvedBidId = computed(() => props.tour.topsort_resolved_bid_id);
    const isRecommended = computed(() => props.tour.recommended);
    const isBlackFriday = computed(() => {
      return false;
    });

    const description = computed(() => cutDescription(props.tour.description));
    const isNew = computed(() => props.tour.is_new);
    const expert = computed(() => {
      const expert = props.tour.expert;
      const avatar = getImageCdnUrl(expert.avatar, 64, 64);
      const avatar1x1 = getImageCdnUrl(expert.avatar, 1, 1)
      const rating = expert.rating ? expert.rating.toFixed(1) : 0;

      return {
        avatar,
        avatar1x1,
        rating,
        name: expert.name,
        reviews: `(${expert.count_reviews || 0})`,
      };
    });
    const type = computed(() => {
      return props.tour.types.find(({ main }) => main).title;
    });

    const imageUrl = computed(() => {
      const width = +imageRef.value?.clientWidth || 276;
      const height = +imageRef.value?.clientHeight || 256;

      return getImageCdnUrl(preview.value, width, height, true);
    });
    const imageUrl1x1 = computed(() => {
      const width = +imageRef.value?.clientWidth || 276;
      const height = +imageRef.value?.clientHeight || 256;

      return getImageCdnUrl(preview.value, width, height, props.lazyImage);
    });

    const imageUrlNoMounted = computed(() => {
      const width = +imageRef.value?.clientWidth || 276;
      const height = +imageRef.value?.clientHeight || 256;

      return getImageCdnUrl(preview.value, width, height, true);
    });

    onMounted(() => {
      mounted.value = true;
    });

    function clickExpert() {
      const url = `/expert/${props.tour.expert.id}/`;

      fakeWindow.open(url, "_blank").focus();
    }
    function cutDescription(desc) {
      let limit = 150;
      let text = desc.replace(/&nbsp;/g," ").replace("&nbsp;"," ");
      if (text.length == 0) {
        return '';
      }
      if (text.length <= limit) {
        return text;
      }
      let firstSpaceIndex = text.indexOf(' ',150);
      let truncatedText = text;
      if(firstSpaceIndex !== -1) {
        truncatedText = text.substr(0, firstSpaceIndex)+ '...';
      }
      return truncatedText;
      /*return desc ?
         desc.replace(/&nbsp;/g," ").replace(/<\/?[^>]+>/g,'').replace("&nbsp;"," ").slice(0,150) + '...' : '';*/
    };
    function setLocalStorageInfo() {
      localStorage.setItem('date_id', String(props.tour.dates.group.id));
      localStorage.setItem('participants', String(props.participants));
    }
    function openTour(type) {
      setLocalStorageInfo();

      ytEvents.track(
        "Tour list",
        "Click Watch tour button",
        props.tour.title,
        {
          id: props.tour.id,
          title: props.tour.title,
          index: props.id,
          elem: type
        });

      fakeWindow.open(link.value, "_blank").focus();
    }

    return {
      tourRef,
      imageRef,
      mounted,
      user,
      type,
      link,
      title,
      description,
      expert,
      isNew,
      preview,
      imageUrlNoMounted,
      imageUrl,
      imageUrl1x1,
      isPrivate,
      isGuarantee,
      isSponsored,
      topsortResolvedBidId,
      isRecommended,
      isBlackFriday,
      setLocalStorageInfo,
      openTour,
      trackEvent,
      clickExpert,
    };
  },
  computed: {
    ...mapState('user', ['favorites']),
    ...mapState('user', ['isLoggedIn']),
    ...mapState({
      currency: (state) => state.currency.currency,
      language: (state) => state.language.language,
      mirIsPromoAvailable: (state) =>
        state.serp?.ordersOptions?.mirIsPromoAvailable,
      mirFirstStartTourDate: (state) =>
        state.serp?.ordersOptions?.mirFirstStartTourDate,
      mirLastFinishTourDate: (state) =>
        state.serp?.ordersOptions?.mirLastFinishTourDate,
    }),
    topsortData() {
      if (!this.isSponsored) {
        return {};
      }

      return {
        'data-ts-product': this.tour.id,
        'data-ts-resolved-bid': this.topsortResolvedBidId,
      };
    },
    isFavorite() {
      return this.favorites?.map(String).includes(this.tour.id.toString());
    },
    isOneDay() {
      const startDate = parseInt(this.tour.dates.group.date_from);
      const endDate = parseInt(this.tour.dates.group.date_to);
      return startDate == endDate;

    },
    getRoute() {
      let route = [];
      let routeLen = 0;
      let maxRoutShortLen = 80;
      let tourLocations = this.tour.locations;
      if(tourLocations.length == 0) {
        return ''
      }
      for(let i = 0; i < tourLocations.length; i++) {
        if (routeLen + tourLocations[i].length + 2 <= maxRoutShortLen) {
          route.push(tourLocations[i]);
          routeLen += tourLocations[i].length + 2
        }
        else {
          break;
        }
      }
      this.moreLocationsAmount = tourLocations.length - route.length;
      return  route.join(', ');
    },
    getFullRoute() {
      let tourLocations = [...this.tour.locations];
      let index = this.tour.locations.length - this.moreLocationsAmount;
      tourLocations.splice(0, index);
      return  tourLocations.join(', ');
    },
    getMoreRouteLocations(){
      return `+${ this.moreLocationsAmount} ${this.$tc( "serp.tourCard.route", this.plural( this.moreLocationsAmount))}`
    },
    getDaysAndNights(){
      const startDate = parseInt(this.tour.dates.group.date_from);
      const endDate = parseInt(this.tour.dates.group.date_to);
      const diffInMs = endDate - startDate;
      const msInOneDay = 60 * 60 * 24;

      const diffInDays = Math.ceil(diffInMs / msInOneDay) + 1;
      const diffInNights =  Math.ceil(diffInMs / msInOneDay);

      return {
        days: `${diffInDays} ${this.$tc( "serp.tourCard.durationDays", this.plural(diffInDays))}`,
        nights: `${diffInNights} ${this.$tc( "serp.tourCard.durationNights", this.plural(diffInNights))}`
      };
    },
    getAwards() {
      if (this.toursWithAwards.indexOf(this.tour.id ) != -1) {
        return {
          code: 'best_tour',
          name: this.$t("serp.awards.bestTours"),
        }
      }

      if (this.tour.expert.id === 9103) {
        return {
          code: 'best_expert',
          name: this.$t("serp.awards.bestExpert"),
        }
      }

      return false;
    },
    getDescriptionForMeta() {
      const description = this.tour.description || "";
      if (description.length) {
        const text = description.replace(/<.*?>/gm, "").split(" ");
        let idx = 0;
        let canIterate = true;
        let out = [];

        while (text[idx] && canIterate) {
          const check = [...out, text[idx]].join(" ");

          if (check.length < 147) {
            out.push(text[idx]);
            idx++;
          } else {
            canIterate = false;
          }
        }
        return out.join(" ") + "...";
      }
      return "";
    },
    getTourCardMeta() {
      const dateFrom = new Date(this.tour.dates.group.date_from * 1000);
      const dateTo = new Date(this.tour.dates.group.date_to * 1000);
      const baseUrl = process.env.VUE_APP_BASE_URL || 'https://youtravel.me';
      const countryUrl = (this.tour.countries?.[0]).toLowerCase(); ""
      const arEmoji = ["&#11088;", "&#128293;", "&#10004;&#65039;", "&#9728;&#65039;", "&#129505;", "&#129523;"];
      const emojiIndex = Math.floor(Math.random() * (5 - 0 + 1)) + 0;

      const regex = /^[^\w\dА-Яа-яёЁ!?+—–−_«»"'.,^;()|\s]+/gu;

      return JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Event",
        name: arEmoji[emojiIndex]+this.title.replace(regex, '').trim(),
        startDate: dateFrom,
        endDate: dateTo,
        url: `${baseUrl}${this.link}`,
        image: [getImageCdnUrl(this.preview, 1000, 1000)],
        eventAttendanceMode: "https://schema.org/OfflineEventAttendanceMode",
        eventStatus: "https://schema.org/EventScheduled",
        description: this.getDescriptionForMeta,
        organizer: {
          "@type": "Person",
          name: `${this.tour.expert.name}.`,
          url: `${baseUrl}${this.tour.expert.link}`,
        },
        performer: {
          "@type": "PerformingGroup",
          name: `${this.tour.expert.name}.`,
          url: `${baseUrl}${this.tour.expert.link}`,
        },
        location: {
          "@type": "Place",
          name: this.location,
          url: `${baseUrl}/tours/country/${countryUrl}`,
          address: {
            "@type": "PostalAddress",
            addressRegion: this.tour.regions?.[0],
            addressCountry: this.tour.countries?.[0],
          },
        },
        offers: {
          "@type": "Offer",
          availability: "https://schema.org/InStock",
          validFrom: dateFrom,
          url: `${baseUrl}${this.link}`,
          price: Math.ceil(this.tour.dates.group.price),
          priceCurrency: this.currency.id,
        },
      }, null, 2);
    },
    location() {
      let locName = this.tour?.regions?.[0] || "";

      if(parseInt(this.locationInfo.seo_optimized) == 1 && this.locationInfo.meta[i18n.locale]['name'] ) {
        locName = this.locationInfo.meta[i18n.locale]['name']
      }
      return [
        this.tour?.countries?.[0] || "",
        locName,
      ]
        .filter((v) => v)
        .join(", ");
    },
    price() {
      const price = Math.ceil(this.tour.dates.group.price)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, " ");

      return `${this.currency?.title.charAt(0)} ${price}`;
    },
    priceDiscount() {
      const pricesWithDiscount = this.tour.dates.group.prices_with_discount;

      if (pricesWithDiscount) {
        const price = Math.ceil(pricesWithDiscount)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, " ");

        return `${this.currency?.title.charAt(0)} ${price}`;
      }

      return "";
    },
    priceDiscountPercent() {
      const discountPercent = Math.ceil(this.tour.dates.group.discount_percent);

      return `-${discountPercent}%`;
    },
    dates() {
      let dates = [];
      let context = this;
      this.tour.dates.slice.forEach(function(item, i) {
        let strDate = {};
        const dateFrom = new Date(item.date_from * 1000);
        const dateTo = new Date(item.date_to * 1000);
        const isYearSame = isSameYear(dateFrom, dateTo);
        const isYearThis = isThisYear(dateFrom);
        const isMonthSame = isSameMonth(dateFrom, dateTo);

        if (!isYearSame) {
          strDate.date = `${format(dateFrom, "d MMMM yyyy", {
            locale: context.isRussian && ru,
          })} - ${format(dateTo, "d MMMM yyyy", {
            locale: context.isRussian && ru,
          })}`;
        } else if (!isMonthSame) {
          strDate.date = `${format(dateFrom, "d MMMM", {
            locale: context.isRussian && ru,
          })} - ${format(dateTo, isYearThis ? "d MMMM" : "d MMMM yyyy", {
            locale: context.isRussian && ru,
          })}`;
        } else {
          strDate.date = `${format(dateFrom, "d", {
            locale: context.isRussian && ru,
          })} - ${format(dateTo, isYearThis ? "d MMMM" : "d MMMM yyyy", {
            locale: context.isRussian && ru,
          })}`;
        }

        if(i == 0) {
          strDate.freeSpaces = false;
          const freeSpaces = item.free_spaces;
          const hasSpaces = freeSpaces && freeSpaces <= 3;

          if (hasSpaces) {
            switch (freeSpaces) {
              case 1:
                strDate.freeSpaces = context.$t("serp.tourCard.places[0]");
                break;
              default:
                strDate.freeSpaces = [
                  item.free_spaces,
                  context.$t("serp.tourCard.places[1]"),
                ].join(" ");
            }
          }
        }
        dates.push(strDate);
      });
      return dates;
    },
    moreDates() {
      return this.tour.dates.total - 1;//this.tour.dates.slice.length;
    },

    showGuaranteeLabel() {
      return (
        abTestController.getSegment(14940) === "B" &&
        this.isRussian &&
        this.isPrivate &&
        this.isGuarantee
      );
    },
    getHours() {

      if (!this.tour?.start_point_time || !this.tour?.finish_point_time) {
        return '';
      }

      const [startHours, startMinutes] = this.tour.start_point_time.split(":").map(Number);
      const [finishHours, finishMinutes] = this.tour.finish_point_time.split(":").map(Number);

      const startTime = new Date();
      startTime.setHours(startHours, startMinutes);
      const finishTime = new Date();
      finishTime.setHours(finishHours, finishMinutes);

      // Вычисляем разницу в миллисекундах
      let difference = finishTime.getTime() - startTime.getTime();

      // Округляем разницу в часах в большую сторону
      difference = Math.ceil(difference / (1000 * 60 * 60));

     return  `${difference} ${this.$tc( "serp.tourCard.durationHours", this.plural(difference))}`;
    },
  },
  methods: {
    ...mapActions("user", ["setFavorites"]),
    toggleFavorite() {
      if (this.pendingFavorite) {
        return;
      }
      const { isFavorite } = this;
      const id = this.tour.id


      ytEvents.track("Tour list", "Click " + (isFavorite ? "Remove" : "Add") + " to favorites button", id);

      if (this.isLoggedIn) {
        this.pendingFavorite = true;
        return axiosUser[isFavorite ? "favouriteRemove" : "favouriteAdd"]({
          id,
        })
          .finally(() => {
            this.pendingFavorite = false;
          })
          .then(
            ({
               data: {
                 data: { favourites },
               },
             }) => {
              this.setFavorites(favourites);
            }
          )
          .catch(console.log.bind(console));
      }
      fakeWindow.showVueAuthModal({ "emit-event": this.eventFavoriteName + "-" + id });
    },
    setIsTablet() {
      this.displayWidth = document.documentElement.clientWidth;
      this.isTablet = this.displayWidth >= 768 && this.displayWidth <= 1255;
    },
    showFullRoute() {
      this.isShowFullRoute = !this.isShowFullRoute;
      ytEvents.track(
        "Tour list",
        "Click Watch more locations",
        this.tour.title,
        {
          id: this.tour.id,
          title: this.title,
          index: this.id,
        });
    },
    plural(n) {
      return n % 10 === 1 && n % 100 !== 11
        ? 0
        : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20)
          ? 1
          : 2;
    },
  },
  mounted() {
    this.setIsTablet();
    fakeWindow.addEventListener("resize", this.setIsTablet);
  },
  beforeDestroy() {
    fakeWindow.removeEventListener("resize", this.setIsTablet);
  },
})
</script>

<style lang="scss" scoped>
.tour-card-horizontal {
  width: 100%;
  background-color: var.$white;
  border-radius: var.$rounded-12 ;
  box-shadow: 1px 2px 45px rgba(153, 153, 169, 0.22);
  min-height: 256px;
  height: fit-content;
  grid-column: span 3;
  display: flex;
  transition: var.$transition-default;

  &:hover {
    color: var.$black;
    box-shadow: 1px 3px 60px rgba(153, 153, 169, 0.35);
  }

  &__link {
    color: var.$black;

    &:visited,
    &:active {
      color: var.$black;
    }
  }

  &__image {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    height: 100%;
    width: 276px;
    border-radius: 12px 0 0 12px;
    overflow: hidden;

    &:after {
      content: "";
      height: 100%;
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background: linear-gradient(
          180deg,
          rgba(0, 0, 0, 0.3) 0%,
          rgba(0, 0, 0, 0.25) 19.68%,
          rgba(0, 0, 0, 0.15) 37.85%,
          rgba(0, 0, 0, 0) 47.83%,
          rgba(0, 0, 0, 0.25) 60.62%,
          rgba(0, 0, 0, 0.65) 80.57%,
          rgba(0, 0, 0, 0.75) 100%
      );
    }

    & > img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      position: absolute;
      border-radius: 12px 0 0 12px;
    }

    &__top {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      width: 100%;
      padding: 12px;
      z-index: 1;

      &__left {
        display: flex;
        align-items: center;
        flex-wrap: wrap;

        > * {
          margin-right: 4px;
          margin-bottom: 4px;
        }
      }

      &__type {
        background: var.$white;
        border-radius: 4px;
        line-height: 17px;
        font-weight: 600;
        font-size: 13px;
        padding: 3px 6px;
      }

      &__private {
        background: var.$white;
        border-radius: 4px;
        padding: 3px 6px;
        font-weight: 600;
        font-size: 13px;
        line-height: 17px;
        letter-spacing: 0.02em;
      }

      &__additional {
        grid-gap: 4px;
        background: #9f18f1;
        color: var.$white;
        border-radius: 4px;
        padding: 3px 6px;
        font-size: 13px;
        font-weight: 600;
        line-height: 17px;
      }

      &__black_friday {
        grid-gap: 4px;
        background: #000000;
        color: var.$white;
        border-radius: 4px;
        padding: 3px 6px;
        font-size: 13px;
        font-weight: 600;
        line-height: 17px;
      }

      &__new {
        color: #fff;
        padding: 3px 6px;
        font-size: 13px;
        font-weight: 600;
        line-height: 17px;
        border-radius: 4px;
        background: #abc232;
      }

      &__favorite {
        justify-self: flex-end;
        margin-top: 2px;

        svg {
          &.favorite {
            fill: var.$white !important;
          }
        }

        &:hover svg {
          fill: var.$gray-dark !important;

          path {
            stroke: var.$gray-dark !important;
          }
        }
      }

      &__super-expert {
        height: 24px;
        padding: 6px 6px 7px 6px;
        justify-content: center;
        flex-shrink: 0;
        border-radius: 6px;
        background: #2E7CF6;
        display: flex;
        align-items: center;
        color: var(--white, #FFF);
        font-size: 13px;
        font-weight: 600;
        line-height: 17px;
        letter-spacing: -0.26px;
        gap: 4px;

        &-icon {
          width: 18px;
          height: 18px;
        }
      }
    }

    &__bottom {
      display: flex;
      align-items: center;
      position: relative;
      justify-content: space-between;
      grid-gap: 10px;
      padding: 16px;
      z-index: 1;
    }

    &__expert {
      display: flex;
      align-items: center;
      margin-top: 12px;

      &__photo {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        object-fit: cover;
        background: #9f18f1;
      }

      &__name {
        color: var.$white;
        margin: 0 4px 0 8px;
        font-size: 13px;
        line-height: 17px;
      }

      &_title {
        max-width: 70%;
      }

      &:hover {
        & .tour-card-horizontal__image__expert__name {
          text-decoration: underline;
        }
      }
    }
  }

  &__body {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    @media (min-width: var.$size-xl) {
      flex-direction: row;
    }

    &__discount {
      padding: 3px 4px;
      color: var.$white;
      background: var.$red;
      border-radius: 5px;
      width: 44px;
      height: 24px;

      @media (min-width: var.$size-xl) {
        position: absolute;
        top: -20px;
        right: -20px;
        font-size: 16px;
        font-weight: 600;
        padding: 14px 8px;
        height: auto;
        width: auto;
        text-align: center;
        border-radius: 0px 12px 0px 10px;
      }
    }

    &__info {
      margin: 20px 20px 0px 21px;
      box-sizing: border-box;

      @media (min-width: var.$size-xl) {
        margin: 20px;
        position: relative;
        max-width: 334px;
      }
    }
    &__price-dates{
      margin: 0 20px 21px 21px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      grid-gap: 12px;

      @media (min-width: var.$size-lg) {
        align-items: flex-end;
      }
      @media (min-width: var.$size-xl) {
        flex-direction: column;
        align-items: flex-start;
        margin: 20px;
        grid-gap: 0;
        justify-content: normal;
        position: relative;
        min-width: 160px;
      }
    }
    &__dates-tablet{
      display: flex;
      margin-top: 16px;
      align-items: center;
      flex-wrap: wrap;
      gap: 4px;
      margin-bottom: 34px;

      @media (min-width: var.$size-lg) {
        margin-bottom: 21px;
      }
    }
    &__dates {
      display: flex;
      margin-top: 10px;
      align-items: center;
      flex-wrap: wrap;
      gap: 6px;
      @media (min-width: var.$size-xl) {
        margin-top: 0;
        justify-content: flex-start;
        grid-gap: 3px;
        padding-bottom: 26px;
      }
    }
    &__date {
      display: flex;
      align-items: center;
      padding: 3px 2px;
      color: #9999a9;
      border: 1px solid #e4e4e8;
      border-radius: 6px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 11px;
      box-sizing: border-box;

      &__free-spaces {
        display: flex;
        align-items: center;
        color: var.$red;
        margin-left: 2px;

        svg {
          margin-right: 2px;
        }
      }
    }

    &__more-dates {
      color: var.$text-dark;
      background: var.$gray-light;
      border-radius: var.$rounded-4;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      padding: 3px 4px;
      font-size: 11px;
      line-height: 14px;
      cursor:pointer;

    }
    &__price {
      display: flex;
      grid-gap: 3px;
      flex-direction: column;
      justify-content: space-between;
      @media (min-width: var.$size-xl) {
        margin-bottom: 17px;
      }
      &__original {
        color: var.$black;
        font-size: 18px;

        &--discount {
          text-decoration: line-through;
          color: var.$secondary;
          line-height: 18px;
          font-size: 13px;

          @media (min-width: var.$size-lg) {
            width: 100%;
            text-align: right;
            margin-bottom: -8px;
            font-size: 12px;
            line-height: 16px;
          }
          @media (min-width: var.$size-xl) {
            text-align: left;
          }
        }
      }

      &__discount {
        color: var.$black;
        font-size: 18px;
      }
      &__duration {
        display: flex;
        grid-gap: 12px;
        justify-content: flex-end;

        @media (min-width: var.$size-xl) {
          justify-content: flex-start;
        }

        &-days, &-nights, &-hours{
          display: flex;
          align-items: center;
          grid-gap: 4px;
          font-style: normal;
          font-weight: 600;
          font-size: 12px;
          line-height: 16px;
          letter-spacing: -0.02em;
          color: #9999A9;
        }
      }
      &-block {
        display: flex;
        grid-gap: 8px;
        justify-content: flex-end;
        align-items: center;

        @media (min-width: var.$size-lg) {
          max-width: 139px;
          flex-wrap: wrap;
        }
        @media (min-width: var.$size-xl) {
          justify-content: flex-start;
        }
      }
    }

    &__rating {
      display: flex;
      align-items: center;
      font-weight: 600;
      font-size: 13px;

      &__icon {
        display: flex;
        margin-right: 2.4px;
        justify-content: center;
        width: 15px;
        height: 14px;

        svg {
          width: 100%;
          height: 100%;
        }
      }

      &__new {
        font-size: 13px;
        line-height: 17px;
        color: var.$green-dark;
      }

      &__rating {
        color: var.$black;
        margin-right: 2.4px;
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        line-height: 16px;
        letter-spacing: -0.02em;
      }

      &__number {
        color: var.$secondary;
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        line-height: 16px;
        letter-spacing: -0.02em;
      }
    }
    &__title {
      color: var.$black;
      display: -webkit-box;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      margin-top: 6px;
      margin-bottom: auto;
      font-size: 16px;
      line-height: 21px;
      cursor: pointer;

      & > a {
        color: var.$black;

        &:visited {
          color: var.$black;
        }
        &:hover {
          color: var.$black;
        }
        &:active {
          color: var.$black;
        }
      }
    }
    &__location {
      font-style: normal;
      font-weight: 600;
      font-size: 12px;
      line-height: 16px;
      letter-spacing: -0.02em;
      color: var.$secondary;
    }
    &__description {
      font-weight: 400;
      height: 57px;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 12px;
      color: #333333;
      margin: 16px 0;
      line-height: 19px;
      letter-spacing: -0.02em;
      font-style: normal;

      @media (min-width: var.$size-xl) {
        margin: 12px 0 40px 0;
        min-width: 360px;
      }
    }
    &__route {
      display: flex;
      @media (min-width: var.$size-xl) {

      }
    }
    &__open-tour{
      width: 135px;
      height: 48px!important;

      @media (min-width: var.$size-xl) {
        width: 160px;
        position: absolute!important;
        bottom: 0;
      }
    }
  }

  &.loading {
    box-shadow: 1px 2px 60px rgba(153, 153, 169, 0.35);

    .tour-card-horizontal__image {
      background: var.$gray-light;
      box-shadow: none;

      & div {
        opacity: 0;
      }

      & img {
        opacity: 0;
      }

      &:after {
        background: var.$gray-light;
      }
    }
    .tour-card-horizontal__body__discount{
      opacity: 0;
    }
    .tour-card-horizontal__body__price-block,
    .tour-card-horizontal__body__date,
    .tour-card-horizontal__body__route{
      background: var.$gray-light;
      border-radius: 4px;
      color: var.$gray-light;
      width: 100%;
      div {
        opacity: 0;
      }
      span {
        opacity: 0;
      }
    }
    .tour-card-horizontal__body__price__duration{
      background: var.$gray-light;
      border-radius: 4px;
      height: 16px;
      div {
        opacity: 0;
      }
    }

    .tour-card-horizontal__body__price__duration-days,
    .tour-card-horizontal__body__price__duration-nights,
    {
      display:none;
    }
    .tour-card-horizontal__body__date__text,
    .tour-card-horizontal__body__date__free-spaces,
    .tour-card-horizontal__body__open-tour,
    .tour-card-horizontal__body__more-dates,
    .route__title,
    .route__block{
      color: var.$gray-light;
    }
    .tour-card-horizontal__body__open-tour{
      color: var.$gray-light;
      transition: none;
    }

    .tour-card-horizontal__body__rating {
      background: var.$gray-light;
      border-radius: 4px;
      div {
        opacity: 0;
      }
    }
    .tour-card-horizontal__body__title {
      text-indent: 100%;
      height: 2em;
      background: var.$gray-light;
      border-radius: 4px;
      span {
        opacity: 0;
      }
    }

    .tour-card-horizontal__body__description {
      text-indent: 100%;
      background: var.$gray-light;
      border-radius: 4px;
      span {
        opacity: 0;
      }
    }

    .tour-card-horizontal__body__expert {
      text-indent: 100%;
      white-space: nowrap;
      overflow: hidden;
      height: 1.5em;
      background: #eeeef2;
      border-radius: 4px;
      border: 0;
      padding: 0;
      width: 100%;

      div,
      img {
        opacity: 0;
      }
    }
  }
}
.awards {
  &_item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    padding: 5px 5px 6px;
    color: #121212;
    margin: 0 8px;
    background: linear-gradient(107.46deg, #FCEF7F 17.49%, #FFC785 95.86%);
    border-radius: 4px;
    font-size: 11px;
    height: 18px;
    white-space: nowrap;
  }

  &_title {
    color: #FDE581;
    margin-bottom: 2px;
  }

  &_photo {
    border: 2px solid #FEE481;
  }

}
.route {
  &__title {
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: -0.02em;
    color:  var.$black;;
  }
  &__block{
    margin-left: 30px;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 19px;
    letter-spacing: -0.02em;
    color: #333333;
  }
  &__text {
    height: fit-content;
    max-height: 40px;
    overflow: hidden;
    transition: var.$transition-default;
  }
  &__text.opened {
    max-height: 500px;
  }
  &__show-more {
    color: #9999A9;
    cursor: pointer;
    display: inline-flex;
  }
}
</style>
